import { clientAPI } from '../configs/configs'
import store from '../store'
import { removeEmptyFields } from '../helpers/normalizers/removeEmptyFields'
import getMarCodigo from '@/helpers/functions/getMarCodigo'

const urlBase = '/returns'
export default class Wallet {
  static async listWalletHistoric(filters) {
    const brand = store.getters['brand/getBrand'] || {}     
    const defaultFilters = {
      con_id: '',
      dt_inicial: '',
      dt_final: '',      
      prt_id: '',
      ped_codigo: '',
      mar_id: brand?.id || '', 
    }

    let requestFilters = Object.assign({}, defaultFilters, filters)
    requestFilters = removeEmptyFields(requestFilters)    
    const request_query_string = new URLSearchParams(requestFilters)
    
    return new Promise((res, rej) => {     
      clientAPI
        .get(`${urlBase}/wallet/b2c`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })     
    })
  } 
  static async sumWalletTransactions(filter) {
    const brand = store.getters['brand/getBrand'] || {}    
    const filterDefault = {
      con_id: '',
      mar_id: brand?.id || '', 
    }

    let requestFilters = Object.assign({}, filterDefault, filter)
    requestFilters = removeEmptyFields(requestFilters)
    const request_query_string = new URLSearchParams(requestFilters)

    return new Promise((res, rej) => {     
      clientAPI
        .get(`${urlBase}/wallet/b2c/total`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })     
    })
  }
  static async getDiscountCoupons(filter) {
    const brand = store.getters['brand/getBrand'] || {}
    const filterDefault = {
      con_id: '',   
      mar_id: brand?.id || '',   
    }
  
    let requestFilters = Object.assign({}, filterDefault, filter)
    requestFilters = removeEmptyFields(requestFilters)
    const request_query_string = new URLSearchParams(requestFilters)
    return new Promise((res, rej) => {     
      clientAPI
        .get(`${urlBase}/wallet/b2c/coupons`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })     
    })
  }
  static async loadCouponsCampaign(filter) {
    const brand = store.getters['brand/getBrand'] || {}     
    const defaultFilters = {     
      mar_codigo: getMarCodigo(brand?.id), 
    }
    const request_query_string = new URLSearchParams(defaultFilters)
    return new Promise((res, rej) => {     
      clientAPI
        .get(`${urlBase}/wallet/b2c/coupons-campaign`, {params: request_query_string})
        .then((response) => {
          res(response.data)
        })
        .catch((error) => {
          rej(error)
        })     
    })
  }
  static async createTransactionGiftCard(fields) {
    const default_fields = {
      emp_codigo: '',
      mar_codigo: '',
      trans_oper: '',
      vco_valor: '',
      vco_token: '',
      vco_code: '',
      vco_idvtex: ''
    }
    const request_body = Object.assign({}, default_fields, fields)
    return new Promise((res, rej) => {      
      clientAPI.post(`${urlBase}/giftcards/transactions`, request_body)      
        .then((response) => {
          res(response.data)
        })
        .catch((err) => {
          rej(err)
        })
    })  
  }  
  static async createCouponVtexModulate(fields) {
    const brand = store.getters['brand/getBrand'] || {}  
    const default_fields = {
      con_id: '',
      cpf: '',
      cli_email: '',
      mar_codigo: getMarCodigo(brand?.id), 
      tic_plataforma: 'SA',
      quant: '',
      tic_codigo: '',
      tcm_dtaexp: '',
      envia_email: 'S',
      prt_id: '',
      mot_id: '',
    }
    const request_body = Object.assign({}, default_fields, fields)
    return new Promise((res, rej) => {      
      clientAPI.post(`${urlBase}/wallet/b2c/coupons`, request_body)      
        .then((response) => {
          res(response.data)
        })
        .catch((err) => {
          rej(err)
        })
    })  
  }
  static async refundGiftCard(fields) {
    const default_fields = {
      con_id: '',
      mar_id: '',
      vlr_estorno: '',
      prt_id: '',
      tipo_pag: '',
      vco_idvtex: '',
      ass_id_ope: '',
      commit: '',
      tipo_vale: 'S'
    }
    const request_body = Object.assign({}, default_fields, fields)
    return new Promise((res, rej) => {      
      clientAPI.post(`${urlBase}/giftcards/refund`, request_body)      
        .then((response) => {
          res(response.data)
        })
        .catch((err) => {
          rej(err)
        })
    })  
  }
}
